import Layout from '../Layout'

export default [
  {
    path: "/login",
    name: "login",
    component: Layout
  }
];
